module.exports = __webpack_public_path__ + "img/1.cf982282.jpg";